import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetBlogListActionType {
  Reset = 'blogList/resetBlogList',
}

export type TResetBlogList = ITypedReduxAction<EResetBlogListActionType.Reset>;
